import { RestService } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EcommerceService {
  apiName = 'Default';
  

  getEcommerceDefaultLink = () =>
    this.restService.request<any, string>({
      method: 'GET',
      responseType: 'text',
      url: '/api/app/ecommerce/ecommerce-default-link',
    },
    { apiName: this.apiName });

  constructor(private restService: RestService) {}
}
